import { render, staticRenderFns } from "./CellGroup.vue?vue&type=template&id=60b34672&"
import script from "./CellGroup.vue?vue&type=script&lang=js&"
export * from "./CellGroup.vue?vue&type=script&lang=js&"
import style0 from "./CellGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports